import React, { useEffect, useState } from "react";
import "../../assets/styles/Search.css";
import Swal from "sweetalert2";
import iconLinkHand from "../../imgs/figma_icons/icon-link-hand.png";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";

function SearchUser() {
  const [userName, setUserName] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiGetSetting();
        if (result && result.status_code === 200 && result.data) {
          setWebSetting(result.data);
        }
      } catch (error) {
        return Swal.fire({
          icon: "error",
          text: "Lỗi kết nối, vui lòng liên hệ CSKH để được hỗ trợ.",
        });
      }
    };
    fetchData();
  }, []);

  const checkUser = async () => {
    if (!userName) {
      return Swal.fire({
        icon: "error",
        text: "Vui lòng nhập tên tài khoản.",
      });
    } else {
      let result = await apiCheckAccount(userName);
      if (result && result?.code === 200) {
        let data = result.data;
        navigate("/profile", { state: { userName, data, webSetting } });
      }
    }
  };

  const getOfficialLink = () => {
    const linkHome = webSetting?.link_home || "https://shbetv9.kim/";
    try {
      const url = new URL(
        linkHome.startsWith("http")
          ? linkHome
          : `https://${linkHome}`
      );
      return url.hostname.toUpperCase();
    } catch (e) {
      return "SHBETV9.KIM";
    }
  };

  return (
    <div className="container">
      <div className="app app-search">
        <Header isPageSearch={true} webSetting={webSetting} />
        <div className="label-search-heading">
          <h1>HỖ TRỢ KHÁCH HÀNG</h1>
        </div>
        <div className="search-img">
          <div className="content app2">
            <div className="search-user">
              <div className="input-search-pill">
                <input
                  className="input-account-pill"
                  value={userName}
                  onChange={(e) =>
                    setUserName(e.target.value.toLowerCase().trim())
                  }
                  onKeyDown={(e) => e.key === "Enter" && checkUser()}
                  type="text"
                  placeholder="Nhập tên đăng nhập"
                />
                <button
                  className="btn-search-account-pill"
                  type="button"
                  onClick={checkUser}
                >
                  KIỂM TRA
                </button>
              </div>

              <div className="notice-glass-card">
                {/* <div className="official-link-row">
                  <span className="official-link-label">Link chính thức:</span>
                  <div className="official-link-box">
                    <img
                      src={iconLinkHand}
                      alt="Link icon"
                      className="icon-link-hand"
                    />
                    <a
                      href={webSetting?.link_home || "https://shbetv9.kim/"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="official-link-url"
                    >
                      {getOfficialLink()}
                    </a>
                  </div>
                </div>
                <div className="notice-bullets">
                  <p className="notice-bullet-item">
                    - SHBET không yêu cầu Hội viên điền thông tin, số điện
                    thoại khi đăng nhập. Nhân viên chính thức của SHBET sẽ không
                    yêu cầu thành viên đăng ký lại tài khoản ở bất kỳ trang web
                    lạ nào và với bất kỳ lý do nào. Nếu quý Hội Viên truy cập
                    thông qua đường link lạ, vui lòng thay đổi mật khẩu ngay
                    lập tức để tránh nguy cơ bị kẻ xấu đánh cắp thông tin.
                  </p>
                  <p className="notice-bullet-item">
                    - Vui lòng sử dụng email của quý Hội viên gửi tin nhắn yêu
                    cầu nhận link vào email chính thức của SHBET:{" "}
                    <span className="text-email-highlight">
                      {webSetting?.email || "admin@shbet.com"}
                    </span>{" "}
                    để nhận được link truy cập mới nhất.
                  </p>
                </div> */}
                <div dangerouslySetInnerHTML={{ __html: webSetting?.login_info_notice }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchUser;

